<template>
  <div>
    <el-navbar />
    <main class="container mt-5">
      <div class="bg-white py-4"></div>
      <div class="mt-5">
        <h2 class="my-3 text-primary">Über uns</h2>
        <div class="row row-cols-2 g-2">
          <div class="col-12 col-md-8 d-flex align-items-center">
            <div class="col">
              <h4>Wir reparieren auch fast alle anderen Handymodelle.</h4>
              <p>Mobile Tech Zone ist ihr starker Partner für Service und Reparatur von Smartphones, Tablets oder Laptops. Unter dem Motto „Reparieren statt Wegwerfen“ schonen wir unsere Umwelt und Ressourcen.
              <br />Unser Team ist auf Reparaturen von Smartphones, Tablets, iPad, Macs, Laptops aller Marken spezialisiert und bietet professionelle, fachgerechte und schnelle Reparaturen mit originalen und qualitativen Ersatzteilen.
              </p>
            </div>
          </div>
          <div class="col-12 col-md-4 mb-4">
            <img src="../../public/storage/repair-desk.jpg" alt="Photo by Abdulhamid kwieder" class="img-fluid shadow rounded" />
          </div>
        </div>
        <h4>Unsere Dienstleistungen:</h4>
        <ul>
          <li>EXPRESS Reparaturen sind bei uns ohne Voranmeldung und für jede Reparatur gewähren wir eine Garantie.</li>
          <li>An- und Verkauf Vertrags freie Handys und Smartphones.</li>
          <li>Zubehör für alle gängigen Marken und Hersteller.</li>
          <li>Software / Datensicherung.</li>
          <li>SIM-Lock / Entsperren.</li>
          <li>UVM…</li>
        </ul>
        <h4>Warum wir?</h4>
        <p>Wir reparieren professionell, fachgerecht und schnell mit originalen und qualitativen Ersatzteilen.</p>
        <p>Professioneller Support, Hilfe bei allen Problemen.
        <br />„WIR BEHEBEN FAST JEDEN SCHADEN“</p>
        <p class="">
          <i class="fa-brands fa-whatsapp text-green"></i>
          <a href="https://wa.me/+43069981170084?text=" class="d-inline-block ms-2" title="Sende uns eine Nachricht per WhatsApp" target="_blank">
            <span class="">Kontaktiere uns per WhatsApp</span>
            <i class="fa-solid fa-sm fa-up-right-from-square ms-1"></i>
          </a>
        </p>
      </div>
    </main>
    <el-footer />
  </div>
</template>

<script>
import elNavbar from "../components/Navbar.vue";
import elFooter from "../components/Footer.vue";

export default {
  name: "About",

  metaInfo() {
    return {
      title: "About",
      titleTemplate: "%s | Mobile Tech Zone",
    };
  },

  components: { elNavbar, elFooter },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.state.utils.loaded = true;
    });
  },

  methods: {},
};
</script>

<style scoped></style>
